import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";

import { PDFSectionsProp } from "../RenderPDF/PDFDocuments";

interface Props {
  title: string;
  buttonLabel: string;
  open: boolean;
  onClose: () => void;
  onSubmit: (sections: PDFSectionsProp) => void;
}

const PDFSectionsDialog: React.FC<Props> = ({
  title,
  buttonLabel,
  open,
  onClose,
  onSubmit,
}) => {
  const { register, getValues, handleSubmit } = useForm({
    defaultValues: {
      mealPlan: true,
      mealPattern: true,
      shoppingList: true,
      householdMeasurements: true,
      foodExchangeList: true,
      commonExchangeList: true,
    },
  });

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        size="small"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <DialogContent>
        <Typography>Sections</Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container>
            <Grid item xs={6}>
              <FormControlLabel
                control={<Checkbox {...register("mealPlan")} defaultChecked />}
                label="Meal Plan"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox {...register("mealPattern")} defaultChecked />
                }
                label="Meal Pattern"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox {...register("foodExchangeList")} defaultChecked />
                }
                label="Food Exchange List"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    {...register("commonExchangeList")}
                    defaultChecked
                  />
                }
                label="Common Exchange List"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox {...register("shoppingList")} defaultChecked />
                }
                label="Shopping List"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    {...register("householdMeasurements")}
                    defaultChecked
                  />
                }
                label="Household Measurements"
              />
            </Grid>
          </Grid>
          <Box display="flex" justifyContent="center" mt={4}>
            <Button type="submit">{buttonLabel}</Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PDFSectionsDialog;
